// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=OkResponseWrappingCurrencyList|schemaHash=c8db3767528e39bb2dfb98605bf2140ccc548c87

import { setDefinedValue } from '@myre/common-primitives';

import { parseCurrencyFromJSON, parseCurrencyToJSON } from './Currency';
import { parseResponseMetaFromJSON, parseResponseMetaToJSON } from './ResponseMeta';

export function parseOkResponseWrappingCurrencyListFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'meta',
    parseResponseMetaFromJSON(
      _data.meta
    ),
  );
  setDefinedValue(
    result,
    'content',
    Array.isArray(_data.content)
      ? _data.content.map(item =>
          parseCurrencyFromJSON(item),
        )
      : _data.content,
  );
  setDefinedValue(result, 'status', _data.status);

  return result;
}

export function parseOkResponseWrappingCurrencyListToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'meta',
    parseResponseMetaToJSON(
      _data.meta
    ),
  );
  setDefinedValue(
    result,
    'content',
    Array.isArray(_data.content)
      ? _data.content.map(item =>
          parseCurrencyToJSON(item),
        )
      : _data.content,
  );
  setDefinedValue(result, 'status', _data.status);

  return result;
}
